import React, {useState} from 'react';
import {Player} from './types';
import {useSwipe} from './useSwipe';

interface Props {
    players: Player[];
    renderCard: (player: Player, index: number) => React.ReactNode;
    onDone: () => void;
}

const PassAndPlay: React.FC<Props> = ({players, renderCard, onDone}) => {
    const [index, setIndex] = useState(0);
    const [revealed, setRevealed] = useState(false);

    const player = players[index];
    const isLast = index + 1 >= players.length;

    const handleReveal = () => setRevealed(true);

    const handleNext = () => {
        if (isLast) {
            onDone();
            return;
        }
        setIndex(index + 1);
        setRevealed(false);
    };

    const swipe = useSwipe({onSwipeUp: revealed ? handleNext : handleReveal, threshold: 70});

    const dragStyle: React.CSSProperties = swipe.dragging
        ? {
            transform: `translateY(${Math.min(0, swipe.offsetY)}px)`,
            opacity: 1 - Math.min(0.5, Math.max(0, -swipe.offsetY) / 260),
            transition: 'none',
        }
        : {transform: 'translateY(0)', opacity: 1};

    if (!revealed) {
        return (
            <div
                className="GmPassCard GmPassCard--swipeable"
                style={dragStyle}
                onTouchStart={swipe.onTouchStart}
                onTouchMove={swipe.onTouchMove}
                onTouchEnd={swipe.onTouchEnd}
            >
                <p className="GmPassCard-hint">Передайте телефон игроку</p>
                <h2 className="GmPassCard-name">{player.name}</h2>
                <button className="GmBtn GmBtn--primary GmBtn--big" onClick={handleReveal}>
                    Я — {player.name}, показать карточку
                </button>
                <p className="GmSwipeHint">▲ или свайпни вверх</p>
                <p className="GmPassCard-progress">{index + 1} / {players.length}</p>
            </div>
        );
    }

    return (
        <div
            className="GmPassCard GmPassCard--swipeable"
            style={dragStyle}
            onTouchStart={swipe.onTouchStart}
            onTouchMove={swipe.onTouchMove}
            onTouchEnd={swipe.onTouchEnd}
        >
            <p className="GmPassCard-warning">⚠ Не показывайте экран остальным!</p>
            <div className="GmPassCard-content">
                {renderCard(player, index)}
            </div>
            <button className="GmBtn GmBtn--big" onClick={handleNext}>
                {isLast ? 'Готово, начать обсуждение' : 'Скрыть и передать дальше'}
            </button>
            <p className="GmSwipeHint">▲ или свайпни вверх</p>
        </div>
    );
};

export default PassAndPlay;
